/** Тексти екранів платформи (українська; англійська — пізніше перекладом каталогів). */
export const platformText = {
  signInLink: 'Увійти',
  create: 'Створити',
  save: 'Зберегти',
  cancel: 'Скасувати',
  saved: 'Збережено',
  history: 'Журнал змін',
  historyCreated: 'створив(-ла) запис',
  historyEmpty: 'Змін ще немає',
  goneDeleted: (time: string | null) => (time ? `Запис видалено · ${time}` : 'Запис видалено'),
  goneMerged: 'Запис об’єднано з іншим',
  /** Картка основного після старої адреси поглиненого (REC-01, DAT-08). */
  mergedHere: (title: string | undefined) =>
    title
      ? `Запис, який ви відкрили, об’єднано в «${title}»`
      : 'Запис, який ви відкрили, об’єднано в цей',
  goneOpen: 'Перейти',
  goneRestore: 'Відновити',
  goneRestoreFailed: 'Не вдалося відновити запис',
  goneEditOff: 'Запис видалено: правка недоступна',
  goneMergedEditOff: 'Запис об’єднано: правка недоступна',
  accessLost: 'Доступ до запису втрачено',
  changedByColleague: 'Запис змінено — показано актуальні дані',
  conflictTitle: 'Поки ви редагували, поле змінили',
  takeTheirs: 'Взяти їхнє значення',
  keepMine: 'Залишити моє',
  forbidden: 'Недостатньо прав для цієї дії',
  notFound: 'Запис не знайдено або він вам недоступний',
  error: 'Не вдалося відкрити сторінку',
  retry: 'Ще раз',
  refreshFailed:
    'Не вдалося оновити дані. Показано останню завантажену версію, ваші зміни збережено в формі',
  slotUnavailable: 'Блок тимчасово недоступний. Оновіть сторінку',
  search: 'Пошук',
  searchChip: (q: string) => `Пошук: «${q}»`,
  searchChipClear: 'Прибрати пошук',
  searchEverywhere: 'Шукати всюди',
  searchTooShort: 'Запит закороткий: потрібне слово від 3 букв',
  searchNoPath: 'Тут шукаємо за номером запису, телефоном чи поштою',
  searchCapped: 'Забагато збігів, уточніть запит',
  automation: 'Автоматизація',
  formUnavailable: 'Не вдалося завантажити форму. Перевірте зв’язок і спробуйте ще раз',
  backToList: 'До списку',
  /** Запис без значень у полях заголовка (рядок списку, підпис чекбокса). */
  untitled: 'Без назви',
  yes: 'Так',
  no: 'Ні',
} as const;
